import React, { useContext } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  VStack,
  Button,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerCloseButton,
  useDisclosure,
  Center,
  WrapItem,
  Wrap,
} from "@chakra-ui/react";
import CreateWallet from "./CreateWalletArb";
import DeployedWallets from "./DeployedWallets";
import SignalsSection from "../SignalsSection";
import VideoPlayer from "../VideoPlayer";
import TenetBox from "./TenetBox";
import GmxPositions from "../gmx/GmxPositions";
import { AppContext } from "../../AppContext";

const WalletTabs = ({
  totalCollateral,
  totalPositions,
  handleTotalCollateralChange,
  handleTotalPositionsChange,
  currentPrice,
  updateTotalBalance,
  handleActiveBalanceUpdate,
  activeBalance,
  tradeSettings,
  handleDataFetched,
  fetchPrice,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { fastestWebSocket, contractAddress } = useContext(AppContext);

  return (
    <>
      <Tabs size="md" variant="unstyled" bg="black">
        <TabList
          p={0}
          bg="#0051ff"
          color="white"
          h="32px" // Reduce height of the bar
          display="flex"
          fontFamily={"Sentinel-light"}
          alignItems="center" // Vertically center items
        >
          <Tab fontSize="sm">Home</Tab>
          <Tab fontSize="sm">Create </Tab>
          <Tab fontSize="sm">Positions </Tab>
          <Button
            ml="auto"
            mr={0.5}
            size="xs"
            onClick={onOpen}
            alignSelf="center" // Ensures vertical centering
          >
            View Accounts
          </Button>
        </TabList>

        <TabPanels>
          <TabPanel p={1} w="100%" bg="black" h="100%">
            <VStack justify="center" p={4}>
              <VideoPlayer />
            </VStack>
          </TabPanel>

          <TabPanel p={0} bg="black">
            <Center>
              <Box p={4} maxWidth="400px">
                <CreateWallet />
              </Box>
            </Center>
          </TabPanel>
          <TabPanel p={0} bg="black">
            <Wrap w="100%" h="100%" bg="gray.300">
              <WrapItem w="100%" minWidth="300px">
                <TenetBox
                  totalCollateral={totalCollateral}
                  totalPositions={totalPositions}
                  handleDataFetched={handleDataFetched}
                  activeBalance={activeBalance}
                />
              </WrapItem>
              <WrapItem w="100%">
                <GmxPositions
                  fastestWebSocket={fastestWebSocket}
                  onTotalCollateralChange={handleTotalCollateralChange}
                  onTotalPositionChange={handleTotalPositionsChange}
                  contractAddress={contractAddress}
                  currentPrice={currentPrice}
                  fetchPrice={fetchPrice}
                  tradeSettings={tradeSettings}
                  handleActiveBalanceUpdate={handleActiveBalanceUpdate}
                />
              </WrapItem>
              <WrapItem overflow="auto" justify="center" w="100%" bg="gray.200">
                <SignalsSection />
              </WrapItem>
            </Wrap>
          </TabPanel>
        </TabPanels>
      </Tabs>

      {/* Right Sliding Drawer for DeployedWallets */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} bg="gray.50">
        <DrawerOverlay />
        <DrawerContent bg="gray.200">
          <DrawerCloseButton />

          <DrawerBody p={1} mt={3}>
            <DeployedWallets />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default WalletTabs;
